/** sessionStorage: `"1"` force on, `"0"` force off. When unset, Leads defaults on for Phase A. */
export const GTM_LEADS_FLAG_KEY = "gtm-leads:enabled";
